import { Card } from "antd";
import { useState } from "react";

type DataItem = {
  name: string;
  learners: number;
};

const countryData: DataItem[] = [
  { name: "Bangladesh", learners: 78432 },
  { name: "India", learners: 54321 },
  { name: "United States", learners: 89765 },
  { name: "England", learners: 32198 },
  { name: "Canada", learners: 47650 },
  { name: "Russia", learners: 91234 },
];

const cityData: DataItem[] = [
  { name: "Dhaka", learners: 38210 },
  { name: "Delhi", learners: 29870 },
  { name: "New York", learners: 41230 },
  { name: "London", learners: 25460 },
  { name: "Toronto", learners: 19890 },
  { name: "Moscow", learners: 36740 },
];

const tabs = ["Country", "City"];

export default function TopPlaces() {
  const [segment, setSegment] = useState("Country");

  const data = segment === "Country" ? countryData : cityData;

  return (
    <>
      <Card
        className="rounded-md shadow-md w-full bg-white"
        bodyStyle={{ padding: "12px" }}
      >
        <div className="justify-start text-zinc-700 text-lg font-medium">
          Top Places
        </div>

        <div className="max-w-xl rounded-md border border-slate-200 bg-white  shadow-sm mt-3">
          {/* Header */}
          <div className="mb-4 flex items-center justify-between p-4 pb-0">
            {/* SEGMENT HEADER */}
            <div className="flex gap-6">
              {tabs.map((tab) => {
                const isActive = segment === tab;

                return (
                  <button
                    key={tab}
                    onClick={() => setSegment(tab)}
                    className={`
                                  pb-1 text-sm font-medium transition-all
                                  ${
                                    isActive
                                      ? "text-[#2D3643] border-b-2 border-[#05152B]"
                                      : "text-[#5E718D] border-b-2 border-transparent hover:text-[#2D3643]"
                                  }
                                `}
                  >
                    {tab}
                  </button>
                );
              })}
            </div>

            <span className="text-sm font-medium text-slate-500">Learners</span>
          </div>
          {/* Table */}
          <div className="divide-y divide-slate-100">
            {data.map((item, index) => (
              <div
                key={index}
                className="flex items-center justify-between py-3 text-sm p-4"
              >
                <span className="text-[#455468]">{item.name}</span>
                <span className="font-medium text-[#455468]">
                  {item.learners.toLocaleString()}
                </span>
              </div>
            ))}
          </div>
        </div>
      </Card>
    </>
  );
}
